// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__17UWV","title":"FrontImage_title__3B3Zh"};